import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/Layout";

import Home from "./pages/Home";
import About from "./pages/About";
import Verticals from "./pages/Verticals";
import VerticalDetail from "./pages/VerticalDetail";
import CSR from "./pages/CSR";
import Newsroom from "./pages/Newsroom";
import NewsDetail from "./pages/NewsDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Gallery from "./pages/Gallery";
import Careers from "./pages/Careers";
import JobDetail from "./pages/JobDetail";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import NotFound from "./pages/NotFound";

const Public = (El) => (
  <Layout>
    <El />
  </Layout>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/" element={Public(Home)} />
          <Route path="/about" element={Public(About)} />
          <Route path="/verticals" element={Public(Verticals)} />
          <Route path="/verticals/:slug" element={Public(VerticalDetail)} />
          <Route path="/csr" element={Public(CSR)} />
          <Route path="/newsroom" element={Public(Newsroom)} />
          <Route path="/newsroom/:slug" element={Public(NewsDetail)} />
          <Route path="/blog" element={Public(Blog)} />
          <Route path="/blog/:slug" element={Public(BlogDetail)} />
          <Route path="/gallery" element={Public(Gallery)} />
          <Route path="/careers" element={Public(Careers)} />
          <Route path="/careers/:slug" element={Public(JobDetail)} />
          <Route path="/contact" element={Public(Contact)} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="*" element={Public(NotFound)} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
